import React, {useCallback, useEffect, useState, useMemo} from 'react';
import {Animated} from "react-animated-css";

import {Link} from "react-router-dom";

import './ChatButton.scss';
import Configuration from "../../../config";
import { useTranslation } from "react-i18next";
import AemService from "../../../helpers/aemService";
import getMenuConfig from "../../../helpers/menuConfig";

const service = new AemService();

/*const CoBrowsingIcon = () => {
  return (
    <svg className="CoBrowsingIcon" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
      <defs>
          <clipPath id="gfwv5lt2ra">
              <path d="M1440 0v901H0V0h1440z"/>
          </clipPath>
          <clipPath id="e7zg34gsab">
              <path d="M20.782 0c.738 0 1.35.538 1.413 1.227l.004.057.001.058v18.316c0 .698-.568 1.277-1.297 1.337l-.06.004-.062.001H15.9v-.789h4.882a.576.576 0 0 0 .578-.471l.005-.04.001-.041V4.895H.834L.834 7.044H0V1.342C0 .644.568.065 1.297.005l.06-.004L1.42 0h19.363zm0 .79H1.418a.576.576 0 0 0-.578.471l-.005.04-.001.041v2.764l20.53-.001V1.342c0-.291-.24-.53-.542-.551L20.78.79zm-3.94 1.658c0 .701-1.068.701-1.068 0 0-.702 1.067-.702 1.067 0zm2.668 0c0 .701-1.067.701-1.067 0 0-.702 1.067-.702 1.067 0zm-5.337 0c0 .701-1.067.701-1.067 0 0-.702 1.067-.702 1.067 0z"/>
          </clipPath>
          <clipPath id="f7ckdgnf8c">
              <path d="M15.357 0c.75 0 1.374.514 1.438 1.186l.004.056.001.047v12.422c0 .669-.575 1.226-1.328 1.285l-.063.003-.053.001H1.444c-.75 0-1.374-.513-1.44-1.186l-.003-.056L0 13.711V1.289C0 .62.575.063 1.328.004l.063-.003L15.357 0zm.594 4.3H.848v9.426l.003.03c.026.274.284.486.593.486h13.929l.034-.002c.307-.023.545-.254.545-.53L15.95 4.3zM15.357.758H1.427L1.393.76c-.307.023-.545.254-.545.53V3.3h15.103V1.274l-.002-.03c-.026-.274-.284-.486-.592-.486z"/>
          </clipPath>
          <clipPath id="8oe3vfkk6d">
              <path d="M.6 0a.6.6 0 1 1 0 1.2.6.6 0 0 1 0-1.2z"/>
          </clipPath>
          <clipPath id="rpohgbtx8e">
              <path d="M4.232 0c2.334 0 4.233 1.89 4.233 4.212 0 2.248-1.837 4.137-4.095 4.21l-.137.002C1.898 8.424 0 6.534 0 4.212 0 1.889 1.898 0 4.232 0zm0 6.258-.229.003-.346.015-.286.022.025.09c.19.675.464 1.158.707 1.288l.065.027.03.006.035.003c.272-.002.612-.528.836-1.33l.024-.084-.133-.012a9.628 9.628 0 0 0-.384-.022l-.19-.005-.155-.001zm1.653.148-.017.07a4.957 4.957 0 0 1-.35.97l-.014.026.034-.013c.462-.184.88-.463 1.228-.822l-.132-.045a6.027 6.027 0 0 0-.67-.171l-.079-.015zm-3.308 0-.078.015a6.003 6.003 0 0 0-.67.171l-.13.044.008.009c.343.352.752.626 1.204.808l.046.018-.013-.026a4.953 4.953 0 0 1-.35-.969l-.017-.07zm-.235-1.8h-1.6l.004.033c.056.46.205.906.433 1.304l.026.044.057-.024A6.13 6.13 0 0 1 2.35 5.65l.081-.016-.016-.123c-.03-.24-.053-.49-.065-.748l-.007-.157zm5.38-.001H6.12l-.006.164c-.01.202-.026.4-.047.593l-.023.192-.012.08.082.015c.402.08.766.185 1.088.314l.057.024.027-.044c.228-.398.376-.844.433-1.304l.003-.034zm-2.459.812c.02-.147.034-.297.046-.452l.015-.235.006-.124H3.132l.005.124c.013.237.033.466.062.687l.015.106.204-.019c.144-.011.287-.02.43-.025l.213-.006.17-.001c.226 0 .456.007.685.023l.331.027.016-.105zm1.996-2.98-.056.024a6.33 6.33 0 0 1-1.242.344l.071-.014.018.133c.024.19.043.385.055.585l.011.202.004.108h1.602l-.003-.034a3.49 3.49 0 0 0-.433-1.304l-.027-.044zM3.203 2.9l.011.001-.016.117c-.02.156-.035.316-.047.48l-.015.249-.003.071H5.33l-.005-.124a8.949 8.949 0 0 0-.061-.686l-.016-.107-.224.02c-.078.006-.155.012-.233.016l-.232.01-.326.005c-.338 0-.685-.017-1.03-.052zM4.23.712l-.027.002c-.263.037-.594.565-.81 1.33l-.023.082.132.012c.128.01.257.017.385.022l.19.005.156.001c.202 0 .407-.006.613-.02l.246-.02-.051-.181c-.195-.648-.463-1.098-.7-1.207L4.277.717l-.03-.004H4.23zM.742 3.818h1.6l.007-.165c.01-.203.027-.401.048-.593l.023-.19.01-.08-.08-.015a6.124 6.124 0 0 1-1.088-.314l-.057-.024-.03.05c-.2.349-.335.725-.403 1.122l-.03.209zm5.149-1.775-.005-.025.078-.015c.292-.058.556-.129.792-.212l.01-.004-.096-.094A3.501 3.501 0 0 0 5.552.97L5.505.953l.013.025c.125.25.232.538.321.86l.052.205zm-4.194-.252.133.04c.137.045.281.085.434.12l.236.052.078.014.017-.07c.095-.366.212-.69.35-.968l.013-.025-.047.018a3.51 3.51 0 0 0-1.13.734l-.084.085z"/>
          </clipPath>
      </defs>
      <g clipPath="url(#gfwv5lt2ra)" transform="translate(-1339 -643)">
          <g clipPath="url(#e7zg34gsab)" transform="translate(1344.7 646)">
              <path fill="#2E384D" d="M0 0h22.2v21H0V0z"/>
          </g>
          <path d="M1365.482 646c.738 0 1.35.538 1.413 1.227l.004.057.001.058v18.316c0 .698-.568 1.277-1.297 1.337l-.06.004-.062.001h-4.881v-.789h4.882a.576.576 0 0 0 .578-.471l.005-.04.001-.041v-14.764h-20.531l-.001 2.149h-.834v-5.702c0-.698.568-1.277 1.297-1.337l.06-.004.062-.001h19.363zm0 .79h-19.363a.576.576 0 0 0-.578.471l-.005.04-.001.041v2.764l20.53-.001v-2.763c0-.291-.24-.53-.542-.551l-.042-.001zm-3.94 1.658c0 .701-1.068.701-1.068 0 0-.702 1.067-.702 1.067 0zm2.668 0c0 .701-1.067.701-1.067 0 0-.702 1.067-.702 1.067 0zm-5.337 0c0 .701-1.067.701-1.067 0 0-.702 1.067-.702 1.067 0z" stroke="#2E384D" strokeWidth=".5" fill="none" strokeMiterlimit="10"/>
          <g clipPath="url(#f7ckdgnf8c)" transform="translate(1341.7 655)">
              <path fill="#2E384D" d="M0 0h16.8v15H0V0z"/>
          </g>
          <path d="M1357.057 655c.75 0 1.374.514 1.438 1.186l.004.056.001.047v12.422c0 .669-.575 1.226-1.328 1.285l-.063.003-.053.001h-13.912c-.75 0-1.374-.513-1.44-1.186l-.003-.056-.001-.047v-12.422c0-.669.575-1.226 1.328-1.285l.063-.003zm.594 4.3h-15.103v9.426l.003.03c.026.274.284.486.593.486h13.929l.034-.002c.307-.023.545-.254.545-.53l-.001-9.41zm-.594-3.542h-13.93l-.034.002c-.307.023-.545.254-.545.53v2.01h15.103v-2.026l-.002-.03c-.026-.274-.284-.486-.592-.486z" stroke="#2E384D" strokeWidth=".5" fill="none" strokeMiterlimit="10"/>
          <g clipPath="url(#8oe3vfkk6d)" transform="translate(1354.9 656.5)">
              <path fill="#2E384D" d="M0 0h1.2v1.2H0V0z"/>
          </g>
          <g clipPath="url(#8oe3vfkk6d)" transform="translate(1352.5 656.5)">
              <path fill="#2E384D" d="M0 0h1.2v1.2H0V0z"/>
          </g>
          <g>
              <g clipPath="url(#8oe3vfkk6d)" transform="translate(1350.1 656.5)">
                  <path fill="#2E384D" d="M0 0h1.2v1.2H0V0z"/>
              </g>
          </g>
          <g>
              <g clipPath="url(#rpohgbtx8e)" transform="translate(1345.861 660.142)">
                  <path fill="#2E384D" d="M0 0h8.465v8.424H0V0z"/>
              </g>
          </g>
      </g>
    </svg>
  )
}*/

const ChatButton = () => {
  //const [open, setOpen] = useState(false);
  //const [isCoBrowserScriptAdded, setIsCoBrowserScriptAdded] = useState(false);
  //const [isCoBrowserInitiated, setIsCoBrowserInitiated] = useState(false);
  //const [isOpenCobrowse, setIsOpenCobrowse] = useState(false);
  const [chatAvailability, setChatAvailability] = useState(false);
  //const [coBrowseDisable, setCoBrowseDisable] = useState(false);
  //const [showCodeEntryText, setShowCodeEntryText] = useState(false);
  const { chatbotInfo } = getMenuConfig();
  const { t } = useTranslation();
  /*const toggleOpenChat = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(!open);
    if (!open) {
      removeChatFrame()
    }
  };*/

  const changeChatButtonStyle = (chatButton$) => {
    if (chatButton$ !== undefined && chatButton$ !== null) {
      if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {
        chatButton$.classList.add('scrollChat');
      } else {
        chatButton$.classList.remove('scrollChat');
      }
    }
  }

  const showChat = () => {
    window.minimizeChat = false;
    window.embeddedservice_bootstrap.bootstrapEmbeddedMessaging();
    //setCoBrowseDisable(true)
  }

  /*const coBrowsingConfiguration = useMemo(()=>({
    'local': {
      webChatConfigurationScriptSrc: 'https://apps.mypurecloud.de/webchat/jsapi-v1.js',
      coBrowsingScriptSrc: 'https://cobrowse.mypurecloud.de/cobrowse-jsapi-v1.js?deploymentKey=BO5LCSFdRXCskhIvjAU3ilN8MduJ0777',
      // Web chat application URL. Use the correct top-level domain for your Genesys Cloud region, i.e. apps.mypurecloud.ie, apps.mypurecloud.jp, apps.mypurecloud.co.uk.
      "webchatAppUrl": "https://apps.mypurecloud.de/webchat",

      // Web chat service URL
      "webchatServiceUrl": "https://realtime.mypurecloud.de:443",

      // Numeric organization ID
      "orgId": 1947,

      // OrgGuid. Needed for co-browse with voice.
      "orgGuid": "bb16fa20-428a-4ec2-98ab-8931029ca9dd",

      // Organization name
      "orgName": "gruppocap",

      // Log level
      "logLevel": "DEBUG",

      // Locale code
      "locale": "it",

      // CSS class applied to the security key window, but not its contents
      "cssClass": "webchat-frame",

      // Custom style applied to the security key window, but not its contents
      "css": {
        "width": "100%",
        "height": "100%"
      },

      // Optional CSS for styling security key form
      // "contentCssUrl": "http://example.com/style.css",
      "contentCssUrl": "https://127.0.0.1:3000/area-riservata/cobrowsing.css",

      // Element id where the security key form will appear.
      "containerEl": "cobrowse-security-form",

      // Set to true to display security key form. Do not include for co-browse with web chat or for PureConnect co-browse with voice.
      "promptForSecurityKey": true
    },
    'alpha': {
      webChatConfigurationScriptSrc: 'https://apps.mypurecloud.de/webchat/jsapi-v1.js',
      coBrowsingScriptSrc: 'https://cobrowse.mypurecloud.de/cobrowse-jsapi-v1.js?deploymentKey=BO5LCSFdRXCskhIvjAU3ilN8MduJ0777',
      // Web chat application URL. Use the correct top-level domain for your Genesys Cloud region, i.e. apps.mypurecloud.ie, apps.mypurecloud.jp, apps.mypurecloud.co.uk.
      "webchatAppUrl": "https://apps.mypurecloud.de/webchat",

      // Web chat service URL
      "webchatServiceUrl": "https://realtime.mypurecloud.de:443",

      // Numeric organization ID
      "orgId": 1947,

      // OrgGuid. Needed for co-browse with voice.
      "orgGuid": "bb16fa20-428a-4ec2-98ab-8931029ca9dd",

      // Organization name
      "orgName": "gruppocap",

      // Log level
      "logLevel": "DEBUG",

      // Locale code
      "locale": "it",

      // CSS class applied to the security key window, but not its contents
      "cssClass": "webchat-frame",

      // Custom style applied to the security key window, but not its contents
      "css": {
        "width": "100%",
        "height": "100%",
        "backgroundColor": "white",
        "visibility": "hidden"
      },

      // Optional CSS for styling security key form
      // "contentCssUrl": "http://example.com/style.css",
      "contentCssUrl": "https://gruppocap-alpha.assistdigital.it/area-riservata/cobrowsing.css",

      // Element id where the security key form will appear.
      "containerEl": "cobrowse-security-form",

      // Set to true to display security key form. Do not include for co-browse with web chat or for PureConnect co-browse with voice.
      "promptForSecurityKey": true
    },
    'beta': {
      webChatConfigurationScriptSrc: 'https://apps.mypurecloud.de/webchat/jsapi-v1.js',
      coBrowsingScriptSrc: 'https://cobrowse.mypurecloud.de/cobrowse-jsapi-v1.js?deploymentKey=BO5LCSFdRXCskhIvjAU3ilN8MduJ0777',
      // Web chat application URL. Use the correct top-level domain for your Genesys Cloud region, i.e. apps.mypurecloud.ie, apps.mypurecloud.jp, apps.mypurecloud.co.uk.
      "webchatAppUrl": "https://apps.mypurecloud.de/webchat",

      // Web chat service URL
      "webchatServiceUrl": "https://realtime.mypurecloud.de:443",

      // Numeric organization ID
      "orgId": 1947,

      // OrgGuid. Needed for co-browse with voice.
      "orgGuid": "bb16fa20-428a-4ec2-98ab-8931029ca9dd",

      // Organization name
      "orgName": "gruppocap",

      // Log level
      "logLevel": "DEBUG",

      // Locale code
      "locale": "it",

      // CSS class applied to the security key window, but not its contents
      "cssClass": "webchat-frame",

      // Custom style applied to the security key window, but not its contents
      "css": {
        "width": "100%",
        "height": "100%",
        "backgroundColor": "white",
        "visibility": "hidden"
      },

      // Optional CSS for styling security key form
      // "contentCssUrl": "http://example.com/style.css",
      "contentCssUrl": "https://gruppocap-beta.assistdigital.it/area-riservata/cobrowsing.css",

      // Element id where the security key form will appear.
      "containerEl": "cobrowse-security-form",

      // Set to true to display security key form. Do not include for co-browse with web chat or for PureConnect co-browse with voice.
      "promptForSecurityKey": true
    },
    'staging': {
      webChatConfigurationScriptSrc: 'https://apps.mypurecloud.de/webchat/jsapi-v1.js',
      coBrowsingScriptSrc: 'https://cobrowse.mypurecloud.de/cobrowse-jsapi-v1.js?deploymentKey=BO5LCSFdRXCskhIvjAU3ilN8MduJ0777',
      // Web chat application URL. Use the correct top-level domain for your Genesys Cloud region, i.e. apps.mypurecloud.ie, apps.mypurecloud.jp, apps.mypurecloud.co.uk.
      "webchatAppUrl": "https://apps.mypurecloud.de/webchat",

      // Web chat service URL
      "webchatServiceUrl": "https://realtime.mypurecloud.de:443",

      // Numeric organization ID
      "orgId": 1947,

      // OrgGuid. Needed for co-browse with voice.
      "orgGuid": "bb16fa20-428a-4ec2-98ab-8931029ca9dd",

      // Organization name
      "orgName": "gruppocap",

      // Log level
      "logLevel": "DEBUG",

      // Locale code
      "locale": "it",

      // CSS class applied to the security key window, but not its contents
      "cssClass": "webchat-frame",

      // Custom style applied to the security key window, but not its contents
      "css": {
        "width": "100%",
        "height": "100%",
        "backgroundColor": "white",
        "visibility": "hidden"
      },

      // Optional CSS for styling security key form
      // "contentCssUrl": "http://example.com/style.css",
      "contentCssUrl": "https://t-www.gruppocap.it/area-riservata/cobrowsing.css",

      // Element id where the security key form will appear.
      "containerEl": "cobrowse-security-form",

      // Set to true to display security key form. Do not include for co-browse with web chat or for PureConnect co-browse with voice.
      "promptForSecurityKey": true
    },
    'production': {
      webChatConfigurationScriptSrc: 'https://apps.mypurecloud.de/webchat/jsapi-v1.js',
      coBrowsingScriptSrc: 'https://cobrowse.mypurecloud.de/cobrowse-jsapi-v1.js?deploymentKey=BO5LCSFdRXCskhIvjAU3ilN8MduJ0777',
      // Web chat application URL. Use the correct top-level domain for your Genesys Cloud region, i.e. apps.mypurecloud.ie, apps.mypurecloud.jp, apps.mypurecloud.co.uk.
      "webchatAppUrl": "https://apps.mypurecloud.de/webchat",

      // Web chat service URL
      "webchatServiceUrl": "https://realtime.mypurecloud.de:443",

      // Numeric organization ID
      "orgId": 1947,

      // OrgGuid. Needed for co-browse with voice.
      "orgGuid": "bb16fa20-428a-4ec2-98ab-8931029ca9dd",

      // Organization name
      "orgName": "gruppocap",

      // Log level
      "logLevel": "DEBUG",

      // Locale code
      "locale": "it",

      // CSS class applied to the security key window, but not its contents
      "cssClass": "webchat-frame",

      // Custom style applied to the security key window, but not its contents
      "css": {
        "width": "100%",
        "height": "100%",
        "backgroundColor": "white",
        "visibility": "hidden"
      },

      // Optional CSS for styling security key form
      // "contentCssUrl": "http://example.com/style.css",
       "contentCssUrl": "https://www.gruppocap.it/area-riservata/cobrowsing.css",

      // Element id where the security key form will appear.
      "containerEl": "cobrowse-security-form",

      // Set to true to display security key form. Do not include for co-browse with web chat or for PureConnect co-browse with voice.
      "promptForSecurityKey": true
    },
  }),[])

  const activateCoBrowsingScript = useCallback(() => {
    const currentEnv = Configuration.get('REACT_APP_ENVIRONMENT');
    let script1 = document.createElement("script");
    if(coBrowsingConfiguration[currentEnv]){
      script1.src = coBrowsingConfiguration[currentEnv].webChatConfigurationScriptSrc;
    }
    script1.async = true;
    let script2 = document.createElement("script");
    if(coBrowsingConfiguration[currentEnv]){
      script2.src = coBrowsingConfiguration[currentEnv].coBrowsingScriptSrc;
    }
    script2.async = true;
    document.body.appendChild(script1);
    document.body.appendChild(script2);
    setIsCoBrowserScriptAdded(true)
  }, [coBrowsingConfiguration]); */

  const handleOpenChat=(e) => {
      e.preventDefault();

      if(e.currentTarget.classList.contains("chatOpen")) {
          var chatIframe = window.embeddedservice_bootstrap.utilAPI.getEmbeddedMessagingFrame();
          window.minimizeChat = true;
          window.embeddedservice_bootstrap.minimizeIframe(chatIframe, {"hasMinimizedNotification": false});
      } else {
          const minChatElements = document.querySelectorAll('iframe.isMinimized');
          if (minChatElements.length !== 0) {
              window.minimizeChat = false;
              var chatIframe = window.embeddedservice_bootstrap.utilAPI.getEmbeddedMessagingFrame();
              window.embeddedservice_bootstrap.maximizeIframe(chatIframe, {"hasMinimizedNotification": false});
          } else {
            console.log("Showing chat");
            showChat();
          }
      }
  }

  const handleKeyDown=(e) => {
    if(e.target.matches("#chatBtn.chatOpen")) {
      if(e.key === "Tab") {
        e.preventDefault();
        document.querySelector("#embedded-messaging iframe").focus();
      }
    }
  }

  /*const initCoBrowsingMain = useCallback(() => {
    const currentEnv = Configuration.get('REACT_APP_ENVIRONMENT');


    const CoBrowsingMain =  () => {
      const {ININ} = window;

      let config =  coBrowsingConfiguration[currentEnv];   // Can also use callback
      return ININ.cobrowse.create(config);

    }

    CoBrowsingMain();

    setTimeout(() => {
      const iframe = document.getElementsByClassName("webchat-frame")[0];

      iframe.onload = () => {
        iframe.style.visibility = "";
        setShowCodeEntryText(true);
      }
    }, 500);

    setIsCoBrowserInitiated(true);
  }, [coBrowsingConfiguration]);

  const removeChatFrame = useCallback(()=>{
    setIsOpenCobrowse(false);
    const element = document.querySelector('#cobrowse-security-form');
    if(element){
      element.style="display:none;"
    }
  },[]);


  useEffect(()=>{
    Promise.all([service.getConfigurations()]).then(r => setChatAvailability(r[0]['chat-availability']?.enabled));

    if(!isCoBrowserScriptAdded){
      activateCoBrowsingScript();
    }

  },[activateCoBrowsingScript, isCoBrowserScriptAdded]);

  const handleToggleCoBrowsing = useCallback(()=>{

    if (!isOpenCobrowse && isCoBrowserScriptAdded) {
      if(!isCoBrowserInitiated){
        initCoBrowsingMain();
      }
      setIsOpenCobrowse(true)
    } else{
      removeChatFrame()
    }

  },[initCoBrowsingMain, isCoBrowserInitiated, isCoBrowserScriptAdded, isOpenCobrowse, removeChatFrame])*/

  useEffect(()=>{
    Promise.all([service.getConfigurations()]).then(r => setChatAvailability(r[0]['chat-availability']?.enabled));
    document.addEventListener('scroll', function (e) {
      changeChatButtonStyle(document.querySelector(".gcap-fab--icon"));
    });
  },[]);

  return (
    <>
      { chatAvailability &&
        <div className="ChatButton" data-testid="ChatButton" id="ChatButton">
          <div className="chat text-right" >
            <div className="d-inline-block">
              <button id="chatBtn" className="gcap-fab--icon" onClick={handleOpenChat} onKeyDown={handleKeyDown} title={t("private.start.chat")} aria-label={t("private.start.chat")}>
                  <div className="closed">
                      <p className="chatButtonText">{chatbotInfo.chatLabel}</p>
                      <span className="align-items-center justify-content-center" aria-hidden="true"></span>
                  </div>
                  <div className="opened"><span className="gc-icon-thick-close h-100 align-items-center justify-content-center"></span></div>
              </button>
            </div>
          </div>
        </div>
      }
    </>
  )
};

ChatButton.propTypes = {};

export default ChatButton;
